var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "set-hotspot" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "70%",
            "lock-scroll": "",
            "destroy-on-close": "",
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("div", { staticClass: "set-hotspot-content" }, [
            _c(
              "div",
              { ref: "mappingRef", staticClass: "mapping" },
              [
                _c("img", {
                  ref: "imageRef",
                  staticClass: "img",
                  attrs: { src: _vm.form.pic },
                  on: { load: _vm.onImageLoad },
                }),
                _vm._v(" "),
                _vm._l(_vm.form.clickList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "hotspotAreaRefs",
                      refInFor: true,
                      staticClass: "hotspot-area",
                      class: {
                        active: _vm.isActive && _vm.hotspotIndex === index,
                      },
                      style: {
                        top: item.top + "px",
                        left: item.left + "px",
                        width: item.width + "px",
                        height: item.height + "px",
                        "z-index": index + 1,
                      },
                      attrs: { "data-area": "hotspotArea" },
                      on: {
                        mousedown: function (e) {
                          return _vm.mousedown(e, index)
                        },
                        click: function ($event) {
                          $event.stopPropagation()
                          return (function (e) {
                            return _vm.areaClick(e, index)
                          })($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.name || "热区" + (index + 1)) +
                          "\n          "
                      ),
                      _vm.isActive && _vm.hotspotIndex === index
                        ? _c("div", {
                            staticClass: "area-icon",
                            on: {
                              mousedown: function ($event) {
                                $event.stopPropagation()
                                return (function (e) {
                                  return _vm.scaleMousedown(e, index)
                                })($event)
                              },
                              click: function ($event) {
                                $event.stopPropagation()
                                return (function (e) {
                                  return _vm.areaClick(e, index)
                                })($event)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "handle" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: !_vm.imageReady },
                    on: { click: _vm.add },
                  },
                  [_vm._v("新增热区")]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    staticClass: "hotspot-form",
                    attrs: { model: _vm.form, "label-width": "110px" },
                  },
                  _vm._l(_vm.form.clickList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "hotspot-item",
                        class: {
                          active: _vm.isActive && _vm.hotspotIndex === index,
                        },
                      },
                      [
                        _c("el-form-item", { attrs: { label: "热区名称：" } }, [
                          _c(
                            "div",
                            { staticClass: "hotspot-name-row" },
                            [
                              _c("el-input", {
                                model: {
                                  value: item.name,
                                  callback: function ($$v) {
                                    _vm.$set(item, "name", $$v)
                                  },
                                  expression: "item.name",
                                },
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-icon-delete hotspot-delete",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeHotspot(index)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "链接：" } },
                          [
                            _c("JumpNative", {
                              model: {
                                value: item.url,
                                callback: function ($$v) {
                                  _vm.$set(item, "url", $$v)
                                },
                                expression: "item.url",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isMiniProgramCustomer
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "核销供应商：" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "hotspot-full",
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: item.offlineSupplierId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "offlineSupplierId", $$v)
                                      },
                                      expression: "item.offlineSupplierId",
                                    },
                                  },
                                  _vm._l(_vm.autoList, function (opt) {
                                    return _c("el-option", {
                                      key: opt.id,
                                      attrs: {
                                        label: opt.supplierName,
                                        value: opt.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("linkaddressVue", {
        ref: "linkaddressVueRef",
        on: { linkUrl: _vm.linkUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }